import { html } from 'lit';

export default function () {
  return html`
    <div class="mp-4">
      <div class="spinner-border"></div>
    </div>
  `;
}
